<template>
	<v-dialog v-model="show" :persistent="true">
		<v-card raised style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
			<v-card-title class="headline grey lighten-2">{{$t('feeding.table-item-title')}}</v-card-title>

			<v-card-text>
				<v-form ref="form">
					<v-row>
						<v-col cols="6">
							<auto-complete
								:is-required="true"
								:value="model.cdRacao"
								@value="newValue => model.cdRacao = newValue"
								:items="feedListRequestStatus.data.data"
								item-text="nmRacao"
								item-value="idRacao"
								:label="$t('common.feed')"
							></auto-complete>
						</v-col>
						<v-col cols="6">
							<numeric-input
								v-model="model.qtKgSuino"
								:is-required="true"
								:greater-than="0"
								:is-float="true"
								:label="$t('feeding.kilos-per-animal')"
							></numeric-input>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>

			<v-card-actions>
				<v-col cols="auto">
					<back-button type="close" @click="dismiss()"></back-button>
				</v-col>
				<v-spacer></v-spacer>
				<v-col cols="auto">
					<save-button @click="save()"></save-button>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { RequestStatusKeys } from '@/modules/common';
import { campoSelectObrigatorio } from '@/filters/rules';

import {
	SaveButton,
	BackButton,
	NumericInput,
	AutoComplete,
} from '@/components';

export default {
	name: 'FeedingTableItemDialog',
	components: {
		SaveButton,
		BackButton,
		NumericInput,
		AutoComplete,
	},
	props: {
		value: Boolean,
		model: {
			type: Object,
			required: true,
		},
		invalidOrderList: Array,
	},
	data() {
		const orderRules = [
			(value) =>
				this.invalidOrderList.indexOf(value) == -1 ||
				this.$t('feeding.order-unique-message'),
		];
		return {
			orderRules,
		};
	},
	computed: {
		...mapState({
			feedListRequestStatus: (state) =>
				state.requestStatus[RequestStatusKeys.FEED_LIST.key],
		}),
		show: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
	},
	methods: {
		campoSelectObrigatorio,
		dismiss() {
			this.$emit('dismiss');
		},
		save() {
			if (this.$refs.form.validate()) {
				const feed = this.feedListRequestStatus.data.data.find(item => item.idRacao === this.model.cdRacao);
				this.model.racao = feed;

				this.$emit('save');
			}
		},
	},
	mounted() {
		this.$store.dispatch('GetFeedListAction');
	},
};
</script>